var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMiconSignature = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "m29.707 5.293-3-3a1 1 0 0 0-1.414 0L19.586 8h-2.491a11.01 11.01 0 0 0-10.383 7.366L2.056 28.67a1 1 0 0 0 1.274 1.274l13.304-4.656A11.01 11.01 0 0 0 24 14.905v-2.49l5.707-5.708a1 1 0 0 0 0-1.414m-7.414 6A1 1 0 0 0 22 12v2.905a9.01 9.01 0 0 1-6.027 8.495l-9.168 3.209L16 17.414 14.586 16 5.39 25.195 8.6 16.027A9.01 9.01 0 0 1 17.095 10H20a1 1 0 0 0 .707-.293L26 4.414 27.586 6z"
})));
export default SvgMiconSignature;